var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.34237 4.9799H11.4046V6.9742H9.34237V4.9799ZM9.34237 8.9685H11.4046V14.9514H9.34237V8.9685ZM10.3735 -0.00585938C4.68181 -0.00585938 0.0625 4.46138 0.0625 9.96565C0.0625 15.4699 4.68181 19.9372 10.3735 19.9372C16.0651 19.9372 20.6844 15.4699 20.6844 9.96565C20.6844 4.46138 16.0651 -0.00585938 10.3735 -0.00585938ZM10.3735 17.9429C5.82633 17.9429 2.12469 14.3631 2.12469 9.96565C2.12469 5.56821 5.82633 1.98844 10.3735 1.98844C14.9206 1.98844 18.6222 5.56821 18.6222 9.96565C18.6222 14.3631 14.9206 17.9429 10.3735 17.9429Z",
    fill: "#006176"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation);
export default __webpack_public_path__ + "static/media/information.5391dc076b340e85d17b7051d1857fbf.svg";
export { ForwardRef as ReactComponent };